const NAVIGATION_TYPES = {
  GENERAL: 'general',
  MAIN: 'main',
  SPECIAL: 'special',
}

export default NAVIGATION_TYPES
